import { useEffect } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import { Box, Grid, media, xcss } from "@atlaskit/primitives";
import { TwcBackground } from "@atlassian/product-wireframes";

import { useSearchParameters } from "@/components/signup/hooks/use-search-parameters.tsx";
import { Modal } from "@/components/signup/layouts/modal";
import {
    experiment,
    useRegisterMetadata
} from "@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks/use-registered-metadata";

import LeftHandSide from "./left-hand-side";
import LeftHandSideV2 from "./left-hand-side-V2";
import RightHandSide from "./right-hand-side";
import { getTeamTypeWithFlow } from "./utils";

const WorkOnFirstView = () => {
    const { teamType } = useSearchParameters();
    const teamTypeValue = getTeamTypeWithFlow(teamType);
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const metadata = useRegisterMetadata();

    const twcAiLedOnboardingCohort = metadata?.get(
        experiment.twcg947TwcLandAiLedOnboarding.cohort
    );
    const isTwcAiLedOnboardingVariation =
        twcAiLedOnboardingCohort === "variation";

    useEffect(() => {
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "workOnFirstScreen",
            attributes: {
                teamType: teamTypeValue,
                twcAiLedOnboardingCohort
            }
        }).fire();
    }, []);

    return (
        <TwcBackground>
            <Modal
                size="lg"
                showBrandFooter={false}
                showProductLogoOnLargeScreens={true}
            >
                <Box xcss={responsiveWrapper}>
                    <Grid gap="space.0" xcss={responsiveGridStyles}>
                        {isTwcAiLedOnboardingVariation ? (
                            <LeftHandSideV2 />
                        ) : (
                            <LeftHandSide teamType={teamTypeValue} />
                        )}
                        <Box xcss={rightHandSideWrapper}>
                            <RightHandSide teamType={teamTypeValue} />
                        </Box>
                    </Grid>
                </Box>
            </Modal>
        </TwcBackground>
    );
};

const responsiveGridStyles = xcss({
    width: "100%",
    height: "100%",
    gridTemplateColumns: "100%",
    [media.above.md]: {
        gridTemplateColumns: "50% 50%"
    }
});

const rightHandSideWrapper = xcss({
    display: "none",
    [media.above.md]: {
        display: "block"
    }
});

const responsiveWrapper = xcss({
    width: "100%",
    maxWidth: "1140px",
    height: "auto",
    overflow: "hidden",
    [media.above.md]: {
        height: "640px"
    }
});

export default WorkOnFirstView;
